var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSystemMarksAndIdentites(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,43.25a.7502.7502,0,0,0-.75.75V70a.7502.7502,0,0,0,.75.75H38a.7502.7502,0,0,0,.75-.75V44a.7502.7502,0,0,0-.75-.75Zm25.25,26H12.75V44.75h24.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.03369,70.75a13.71656,13.71656,0,1,0-13.7168-13.71631A13.73211,13.73211,0,0,0,57.03369,70.75Zm0-25.93311a12.21656,12.21656,0,1,1-12.2168,12.2168A12.23026,12.23026,0,0,1,57.03369,44.81689Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.63818,38.39453a.75172.75172,0,0,0,.03272-.73l-14-28a.78134.78134,0,0,0-1.3418,0l-14,28A.74978.74978,0,0,0,26,38.75H54A.75133.75133,0,0,0,54.63818,38.39453ZM27.21338,37.25,40,11.67725,52.78662,37.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSystemMarksAndIdentites);
export default __webpack_public_path__ + "static/media/icon_system_marks_and_identites.371296c1c9ebda74fb9ac2c4d2380e6d.svg";
export { ForwardRef as ReactComponent };